import React from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";

// ASSETS
import { ProfilePictureStyles } from "./index.style";
import { ProfilePictureProps } from "./types";
import anonProfilePic from "./anon-profile-pic.png";
/*
  if props.picture is undefined, then an anon profile picture will be used instead.
*/

const ProfilePicture = (props: ProfilePictureProps) => {
  const classes = ProfilePictureStyles();
  return (
    <Grid container alignItems="center" justifyContent="center" item className={classes.container}>
      <Grid item className={classes.picture}>
        <img
          src={props.picture || anonProfilePic}
          alt="Profile"
          width="70px"
          height="70px"
          style={{ borderRadius: "50%" }}
        />
      </Grid>
    </Grid>
  );
};

export default ProfilePicture;
